import { setToken } from '@/utils/auth';
import { setStore, getStore } from '@/utils/store';

const login = {
  state: {
    token: getStore({ name: 'token' }) || '',
    forget: true,
    titleActive: true,
    showLoading: false
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      setToken(token);
      state.token = token;
      setStore({ name: 'token', content: state.token, type: 'session' });
    },
    SET_FORGET(state, forget) {
      state.forget = forget;
    },
    SET_TITLE_ACTIVE(state, titleActive) {
      state.titleActive = titleActive;
    },
    upDateLoading(state, showLoading) {
      state.showLoading = showLoading;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    }
  }
};

export default login;
